import React from 'react'
import Footer from '../components/Footer'
import HeroServices from '../components/HeroServices'
import Navbar from '../components/Navbar'
import Products from '../components/Products'

const Services = () => {
  return (
    <div>
        <Navbar />
        <HeroServices />
        <Products />
        <Footer />
    </div>
  )
}

export default Services